export class UserActionLog {
    Log_ID!: number;
    FirmMPID!: string;
    User_ID!: string;
    User_Action!: string;
    Application!: string;
    Text1!: string;
    Text2!: string;
    Created_Date!: string;
}